/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { Config, CONFIG } from '../../config';
const config: Config = CONFIG;

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = config.urlApi;
}

/**
 * Parameters for `ApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
